import httpClient from "@/services/httpClient";
import { server, dispute_resolution_const } from "@/services/constants";

const api_core = `${dispute_resolution_const.dispute_resolution_url}`

export const dispute_resolution_getall_courtstatus = () => {
    return httpClient.get(`${api_core}/${server.LITIGATION_COURT_STATUS}/`);
};
export const dispute_resolution_getbyid_courtlevelstatus = (id) => {
    return httpClient.get(`${api_core}/${server.LITIGATION_COURT_STATUS}/by-id/${id}`);
};
export const dispute_resolution_add_courtlevelstatus = (data) => {
    return httpClient.post(`${api_core}/${server.LITIGATION_COURT_STATUS}/`, data);
};
export const dispute_resolution_update_courtlevelstatus = (id, data) => {
    return httpClient.put(`${api_core}/${server.LITIGATION_COURT_STATUS}/${id}`, data);
};
export const dispute_resolution_delete_courtlevelstatus = (id) => {
    return httpClient.delete(`${api_core}/${server.LITIGATION_COURT_STATUS}/${id}`);
};
